import type {ReactElement} from 'react';
import React from 'react';
import {TabsToggleSize, TabToggleData, TabToggleVariant} from '@Components/tabs-toggle/tabs-toggle.types';
import {ClickableDiv} from '@Components/clickable-div';
import {Text, TextSize} from '@Components/text';
import styles from './tab-square.module.scss';

interface TabSquareProps {
  className?: string;
  size?: TabsToggleSize;
  variant?: TabToggleVariant;
  data: TabToggleData;
  isSelected?: boolean;
  onClick(): void;
}

export function TabSquare({className = '', isSelected = false, size = TabsToggleSize.MEDIUM, variant = TabToggleVariant.DEFAULT, ...props}: TabSquareProps): ReactElement<any> | null {
  const getSizeClasses = (): string => {
    switch (size) {
      case TabsToggleSize.XSMALL:
        return `${styles.xsmall} flex-center`;
      case TabsToggleSize.SMALL:
        return styles.small;
      case TabsToggleSize.MEDIUM:
      default:
        return styles.medium;
    }
  };

  const getVariantClasses = (): string => {
    if (!isSelected) {
      return '';
    }

    switch (variant) {
      case TabToggleVariant.LIGHT:
        return styles.light;
      case TabToggleVariant.DEFAULT:
      default:
        return styles.defaultColor;
    }
  };

  const getTextSizeFromTabSize = (): TextSize => {
    switch (size) {
      case TabsToggleSize.XSMALL:
      case TabsToggleSize.SMALL:
        return TextSize.XXSMALL;
      case TabsToggleSize.MEDIUM:
      default:
        return TextSize.XSMALL;
    }
  };

  const getTextColorClasses = (): string => {
    if (!isSelected) {
      return 'content-body';
    }
    switch (variant) {
      case TabToggleVariant.LIGHT:
        return 'content-primary';
      case TabToggleVariant.DEFAULT:
      default:
        return 'content-body-white';
    }
  };

  return (
    <ClickableDiv
      onClick={(): void => {
        props.onClick();
      }}
      className={`${className} hover-transition-all ${isSelected ? styles.selected : ''} ${styles.container} radius-4 ${getVariantClasses()} ${getSizeClasses()}`}
    >
      <Text val={props.data.text} className={getTextColorClasses()} bold size={getTextSizeFromTabSize()} />
    </ClickableDiv>
  );
}
